import { SxProps } from '@mui/material';
import { grey, grey10, red2 } from 'app/components/ThemeProvider/colors';

export const inputBox: SxProps = {
  display: 'flex',
  // justifyContent: 'space-between',
  flexDirection: 'column',
  gap: '8px',
  width: '320px',

  '& .Mui-disabled': {
    background: grey10,
  },

  '@media screen and (max-width: 1100px)': {
    width: '100%',
    // 'calc((100% - 28px) / 2)',
  },
};

export const inputOutlined = (isValid: boolean) => {
  return {
    fontSize: '16px',
    fontWeight: 400,
    borderWidth: '1px',
    borderRadius: '8px',
    height: '48px',
    lineHeight: 1,

    // '& .MuiInputBase-input::placeholder': {
    //   fontSize: '16px',
    //   fontWeight: '400px',
    //   color: 'rgba(20, 25, 31, 0.4)',
    // },
    //
    // '& .MuiInputBase-input': {
    //   fontSize: '16px',
    //   fontWeight: '400',
    //   overflow: 'hidden',
    //   whiteSpace: 'nowrap',
    //   textOverflow: 'ellipsis',
    // },
    //
    // '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    //   borderColor: isValid ? red2 : grey,
    //   borderWidth: '0.5px',
    // },
    //
    // '&.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
    //   borderColor: red2,
    //   borderWidth: '0.5px',
    // },
    //
    // '&.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
    //   borderColor: 'rgba(20, 25, 31, 0.10)',
    // },
    //
    // '& .Mui-disabled': {
    //   background: grey10,
    // },
  };
};
